module.exports = __webpack_public_path__ + "img/edo.0ecb7b83.svg";